import { useState } from 'react';
import { Button, Field, Modal } from '../ui';
import { studentApi, apiErrorMessage } from '../../services/api';
import { useOrg } from '../../context/OrgContext';
import { useToast } from '../../context/ToastContext';

export default function StudentDialog({ batches, onClose, onInvited }) {
  const org = useOrg();
  const toast = useToast();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ email: '', batchId: batches[0]?.id || '' });

  const handleInvite = async () => {
    setSaving(true);
    try {
      await studentApi.invite(org.id, {
        email: form.email.trim(),
        ...(form.batchId && { batchId: form.batchId })
      });
      toast.success('Student invitation created.');
      onInvited();
    } catch (err) {
      toast.error(apiErrorMessage(err, 'Failed to invite student'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title="Invite student" onClose={onClose}>
      <div className="form">
        <p className="helper">The student must already have a Prepgen.ai account with this email. They will join as a pending member.</p>
        <Field label="Email">
          <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </Field>
        <Field label="Batch">
          <select value={form.batchId} onChange={(e) => setForm({ ...form, batchId: e.target.value })}>
            <option value="">Unassigned</option>
            {batches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
          </select>
        </Field>
        <div className="modal-actions">
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button disabled={!form.email.trim() || saving} onClick={handleInvite}>
            {saving ? 'Inviting…' : 'Invite'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
